import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceArea, CartesianGrid } from "recharts";
import { formatDateAU } from "@/lib/formatDateAU";

const SAFE_RANGES = {
  ph: [6.5, 8.5],
  conductivity: [0, 800],
  tds: [0, 500],
  e_coli: [0, 0],
  coliforms: [0, 0],
};

const LABELS = {
  ph: "pH", conductivity: "Conductivity (µS/cm)", tds: "TDS (mg/L)",
  e_coli: "E. coli (CFU)", coliforms: "Coliforms (CFU)",
};

export function TrendChart({ tests, parameter = "ph", height = 220 }) {
  const data = [...tests].reverse().map((t) => ({
    date: formatDateAU(t.collected_at),
    value: t.parsed_results?.[parameter] ?? null,
  })).filter((d) => d.value !== null && d.value !== undefined);

  const safe = SAFE_RANGES[parameter];
  const allValues = data.map((d) => d.value);
  const min = Math.min(...allValues, safe?.[0] ?? 0);
  const max = Math.max(...allValues, safe?.[1] ?? 1);

  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center bg-slate-50 rounded-2xl text-sm text-slate-400" style={{ height }}>
        Not enough data yet for {LABELS[parameter]}
      </div>
    );
  }

  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">{LABELS[parameter]}</div>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748B" }} />
          <YAxis tick={{ fontSize: 11, fill: "#64748B" }} domain={[Math.floor(min * 0.9), Math.ceil(max * 1.1)]} />
          {safe && <ReferenceArea y1={safe[0]} y2={safe[1]} fill="#10B981" fillOpacity={0.08} />}
          <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0", fontSize: 12 }} />
          <Line type="monotone" dataKey="value" stroke="#06B6D4" strokeWidth={2.5} dot={{ r: 4, fill: "#06B6D4" }} activeDot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
